<template>
  <div class="notFound-Main">
    <h1>Not Found</h1>
    <hr>
    <p>HTTP Error 404. The requested resource is not found.</p>
  </div>
</template>

<script>
export default {
  name: 'CatchNotFound'
};
</script>

<style>
.notFound-Main {
  padding: 10px;
}
hr {
  border: 0;
  border-top: 1px solid #000;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/catchNotFound.vue